
import { Ref, defineComponent, provide, ref } from "vue";

export default defineComponent({
  props: {
    isClickable: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: false
    }
  },
  emits: ["click"],
  setup(props, { emit }) {
    const dropdown = ref();
    const isCollapsed: Ref<boolean> = ref(false);

    provide("isCollapsed", isCollapsed);

    const onCollapse = (): void => {
      if (!props.isClickable) return;

      if (!isCollapsed.value) {
        emit("click");
      }

      isCollapsed.value = !isCollapsed.value;

      if (!isCollapsed.value) {
        setTimeout(() => {
          const parentElement = document.getElementById(
            "ongoing"
          ) as HTMLDivElement;

          if (props.id && parentElement && dropdown.value) {
            const distanceFromTop = dropdown.value.offsetTop;
            parentElement.scrollTo(0, distanceFromTop - 50);
          }
        }, 5);
      }
    };

    return {
      onCollapse,
      isCollapsed,
      dropdown
    };
  }
});
